import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Slide,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { forwardRef } from "react";
import ModalButton from "./ModalButton";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Modal(props) {
  const {
    confirmDialogAction,
    setConfirmDialogAction,
    isLoadingModalConfirmation,
  } = props;

  return (
    <Dialog
      open={confirmDialogAction.isOpen}
      maxWidth="md"
      TransitionComponent={Transition}
      scroll={confirmDialogAction.scroll}
      sx={{ maxHeight: "650px" }}
      data-no-dnd="true"
    >
      <Backdrop
        open={isLoadingModalConfirmation}
        style={{ zIndex: 9999 }}
        sx={{ color: "#fff" }}
      >
        <CircularProgress color="inherit" size={60} />
      </Backdrop>

      <DialogTitle
        component="div"
        style={{
          marginTop: "5px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {confirmDialogAction.children}
        <IconButton
          className="XmodalCloseButton"
          onClick={() =>
            setConfirmDialogAction({ ...confirmDialogAction, isOpen: false })
          }
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers component="div" sx={{ marginTop: -1 }}>
        <Typography variant="h6" sx={{ fontSize: "16px" }}>
          {confirmDialogAction.title}
        </Typography>
        <Typography variant="subtitle2" sx={{ fontSize: "12px" }}>
          {confirmDialogAction.subTitle}
        </Typography>
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "15px",
          marginTop: "8px",
        }}
      >
        {!confirmDialogAction.showCancelWithAction && (
          <ModalButton
            text={confirmDialogAction.closeTextButton}
            variant="outlined"
            size="small"
            onClick={() =>
              setConfirmDialogAction({ ...confirmDialogAction, isOpen: false })
            }
          />
        )}
        {confirmDialogAction.showCancelWithAction && (
          <ModalButton
            text={confirmDialogAction.confirmTextCloseButton}
            variant="outlined"
            size="small"
            onClick={confirmDialogAction.onConfirmAndClose}
          />
        )}
        {confirmDialogAction.showConfirmationButton && (
          <ModalButton
            text={confirmDialogAction.confirmTextButton}
            size="small"
            color={confirmDialogAction.color}
            onClick={confirmDialogAction.onConfirm}
          />
        )}
      </DialogActions>
    </Dialog>
  );
}
